import { ToggleIconButton as CommonToggleIconButton, type ToggleIconButtonProps } from '@monorepo/common';

function ToggleIconButton(props: ToggleIconButtonProps) {
  return <CommonToggleIconButton {...props} />;
}

export default ToggleIconButton;
